/** Use admin "hero blurb" when set; otherwise `fallback` (e.g. design count line). */
export function categoryHeroBlurb(meta, fallback) {
  const custom = String(meta?.hero_blurb ?? '').trim();
  if (custom) return custom;
  return fallback ?? '';
}

/** Use admin "hero tagline" when set; otherwise `fallback` (can be empty string to hide). */
export function categoryHeroTagline(meta, fallback) {
  const custom = String(meta?.hero_tagline ?? '').trim();
  if (custom) return custom;
  return fallback ?? '';
}
